import styled from "styled-components";

const StyledLink = styled.span`
    font-size: 13.98px;
    color: rgba(82, 182, 255, 1);
    text-decoration: underline;
`;

export default StyledLink;